import { render, staticRenderFns } from "./dPhoneField.vue?vue&type=template&id=1157f600&scoped=true&"
import script from "./dPhoneField.vue?vue&type=script&lang=js&"
export * from "./dPhoneField.vue?vue&type=script&lang=js&"
import style0 from "./dPhoneField.vue?vue&type=style&index=0&id=1157f600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1157f600",
  null
  
)

export default component.exports